<template>
  <a-card :loading="loading" :body-style="{ padding: '20px 24px 8px' }" :bordered="false">
    <div class="chart-card-header">
      <div class="meta">
        <span class="chart-card-title">{{ title }}</span>
        <a-tooltip :title="chartTips" class="chart-card-action">
          <a-icon type="info-circle-o" />
        </a-tooltip>
      </div>
      <div class="meta">
        <div class="total">
          <span>{{ total }}</span>
        </div>
        <span class="chart-card-others">{{ rightTitle }}:{{ rightNum }}</span>
      </div>
    </div>
    <div class="area-container" :id="uniqueId"></div>
  </a-card>
</template>

<script>
import { Line } from "@antv/g2plot";
import moment from 'moment';
export default {
  props: {
    loading: { default: true, type: Boolean, required: true },
    chartTips: { default: "", type: String },
    title: {
      default() {
        return this.$t('charts.totalViews')
      },
      type: String
    },
    total: { default: 0, type: [Number, String], required: true },
    rightTitle: {
      default() {
        return this.$t('charts.dayViews')
      },
      type: String,
      required: true
    },
    rightNum: { default: 0, type: [Number, String], required: true },
    dataHeight: { default: 300, type: Number },
    theme: { default: "#ae48ea", type: String },
    uniqueId: { default: "areacontainer", type: String, required: true },
    xField: { default: "stat_date", type: String },
    yField: { default: "visit_count", type: String },
    yAlias: {
      default() {
        return this.$t('charts.views')
      },
      type: String
    },
  },
  data() {
    return {
      areaPlot: null,
      datas: [],
      dateFormat: "YYYY-MM-DD 23:59:59",
    };
  },
  computed: {
    moment,
  },
  mounted() {
    const data = this.datas;
    this.areaPlot = new Line(document.getElementById(this.uniqueId), {
      forceFit: true,
      smooth: false,
      color: this.theme,
      height: this.dataHeight,
      data,
      meta: {
        [this.xField]: {
          alias: this.$t('charts.date'),
        },
        [this.yField]: {
          alias: this.yAlias,
        },
      },
      xField: this.xField,
      yField: this.yField,
      xAxis: {
        visible: true,
        tickCount: 64,
        // min: this.startDate,
        // max: this.endDate,
      },
      yAxis: {
        visible: true,
      },
    });
    this.areaPlot.render();
  },
  methods: {
    update(newData) {
      this.areaPlot.changeData(newData);
      // console.log('new data', newData);
    },
  },
};
</script>

<style scoped>
.area-container {
  width: 100%;
  height: 100%;
}

.chart-card-title {
  color: rgba(179, 179, 179, 1);
  font-size: 14px;
}

.chart-card-header {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.meta {
  /* position: relative; */
  overflow: hidden;
  width: 100%;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chart-card-action {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
}

.total {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
  color: #000;
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 30px;
  line-height: 38px;
  height: 38px;
}
</style>